import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import {
  GlobalMessageComponentModule,
  KeyboardFocusModule,
  OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
  SkipLinkModule,
} from '@spartacus/storefront';
import { RouterModule } from '@angular/router';
import { MenuCategoryMobileComponent } from './menu-category-mobile/menu-category-mobile.component';
import { HeaderMobileComponent } from './header-mobile/header-mobile.component';
import { HeaderDesktopComponent } from './header-desktop/header-desktop.component';
import { MenuCategoryDesktopComponent } from './menu-category-desktop/menu-category-desktop.component';
import { IconHamburguerComponent } from './icon-hamburguer/icon-hamburguer.component';
import { ScreenViewModule } from '../../../../../core/directives/screen-view/_screen-view.module';

@NgModule({
  declarations: [
    HeaderComponent,
    HeaderMobileComponent,
    HeaderDesktopComponent,
    MenuCategoryMobileComponent,
    MenuCategoryDesktopComponent,
    IconHamburguerComponent,
  ],
  imports: [
    CommonModule,

    RouterModule,
    GlobalMessageComponentModule,
    OutletModule,
    OutletRefModule,
    PageLayoutModule,
    PageSlotModule,
    KeyboardFocusModule,
    SkipLinkModule,
    ScreenViewModule,
  ],
  exports: [HeaderComponent],
})
export class HeaderModule {}
